import { render, staticRenderFns } from "./HbGlobalNotification.vue?vue&type=template&id=e54acd8e&scoped=true&"
import script from "./HbGlobalNotification.vue?vue&type=script&lang=js&"
export * from "./HbGlobalNotification.vue?vue&type=script&lang=js&"
import style0 from "./HbGlobalNotification.vue?vue&type=style&index=0&id=e54acd8e&prod&scoped=true&lang=css&"
import style1 from "./HbGlobalNotification.vue?vue&type=style&index=1&id=e54acd8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54acd8e",
  null
  
)

export default component.exports